import type { PartnerTenant } from '@shipium-corp/shipium-ts-types';
import { isWithinInterval } from 'date-fns';
import type { Schedule, ScheduleEntry } from '../../services/FP_FulfillmentContextService/types';
import type { HydrationAssetError, ValidationInfo } from '../types';
import { extractTenantDetails, findScopedTenant, generateHydrationError, isActiveAsset } from './utils';
const scheduleAssetType = 'schedule';

export const generateScheduleValidationInfo = (schedule?: Schedule, entry?: ScheduleEntry): ValidationInfo => {
  const scheduleConfigured = isActiveAsset(schedule);
  const activeEntryConfigured = !!entry;
  const scheduleLinkError = !schedule ? generateHydrationError('Not configured', scheduleAssetType) : null;
  const scheduleActiveError =
    !scheduleConfigured && schedule
      ? generateHydrationError('Not active', scheduleAssetType, schedule?.scheduleId)
      : null;
  const entryError = !activeEntryConfigured
    ? generateHydrationError('No active calendar entry', scheduleAssetType, schedule?.scheduleId)
    : null;
  const errors = [scheduleLinkError, scheduleActiveError, entryError].filter(
    (msg): msg is HydrationAssetError => !!msg,
  );
  const valid = !errors.length;
  return {
    errors,
    configurationValid: valid,
    warnings: [],
    configurationComplete: valid,
  };
};

export const hydrateSchedule = (tenantList: PartnerTenant[], schedule?: Schedule) => {
  const activeScheduleEntry = schedule?.entries?.find((entry) =>
    isWithinInterval(Date.now(), {
      start: Date.parse(entry.from),
      end: Date.parse(entry.to),
    }),
  );
  const tenant = schedule ? findScopedTenant(schedule.scheduleId, 'schedules', tenantList) : null;
  return {
    ...(schedule ?? {}),
    ...(tenant ? { tenant: extractTenantDetails(tenant) } : {}),
    activeScheduleEntry,
    validationInfo: generateScheduleValidationInfo(schedule, activeScheduleEntry),
  };
};
